import { gql } from '@apollo/client/core';
import AppLayout from '@components/AppLayout';
import { filterProductsQuery } from '@components/components/Filters/FiltersQuery';
import CentraCategoryPageContext from '@components/contexts/CentraCategoryPageContext';
import { CategoryPage } from '@components/pages/CategoryPage';
import {
  buildQueryVars,
  useProducts,
} from '@components/pages/CategoryPage/StateContainer/hooks/useProducts/useProducts';

import { addApolloState, initializeApollo } from '../lib/apolloClient';

const POST_URI_QUERY = gql`
  query POST_URI_QUERY($uri: String!) {
    products(uri: $uri) {
      found
    }
  }
`;

// TODO: optimization
// export const getStaticPaths = async () => {
//   return {
//     paths: [],
//     fallback: 'blocking',
//   };
// };

// TODO: optimization
export const getServerSideProps = async (context: any) => {
  let error: Error;
  const { params } = context;
  const apolloClient = initializeApollo();
  const queryVariables = buildQueryVars(params);
  const checkCategory = await apolloClient.query({ query: POST_URI_QUERY, variables: { uri: params.uri.join('/') } });

  if (checkCategory.data?.products?.found === 'product') {
    return {
      props: {},
      redirect: {
        destination: `/product/${params.uri.join('/')}`,
        statusCode: 302,
      },
    };
  }

  const res = await apolloClient
    .query({
      query: filterProductsQuery,
      variables: queryVariables,
    })
    .catch((e: Error) => {
      error = e;

      console.log('Error in CategoryPage SSR', JSON.stringify(e));
    });

  const hasProducts = (res as any)?.data?.filterProducts?.products?.length > 0;

  return addApolloState(apolloClient, {
    props: error
      ? { error }
      : {
          centraData: (res as any)?.data,
        },
    notFound: !hasProducts,
    // revalidate: REVALIDATE_CENTRA_PAGES_AFTER,
  });
};

const CategoryRoute = props => {
  const context = useProducts({ data: props.centraData });

  if (props.error) {
    return <pre>{props.error}</pre>;
  }

  return (
    <AppLayout>
      <CentraCategoryPageContext.Provider value={{ ...props, ...context }}>
        <CategoryPage />
      </CentraCategoryPageContext.Provider>
    </AppLayout>
  );
};

export default CategoryRoute;
